import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LanguageSwitcher from '../ui/LanguageSwitcher';
import ThemeToggle from '../ui/ThemeToggle';

const Header = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="flex items-center justify-between px-6 py-3 border-b border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900">
      <div className="flex items-center gap-4">
        <span className="material-symbols-outlined text-primary text-2xl">diamond</span>
        <span className="font-bold text-lg text-[#111418] dark:text-white">Digital Accounting Platform</span>
      </div>
      {/* Masaüstü linkler */}
      <div className="hidden md:flex items-center gap-6">
        <button
          className="text-sm font-medium text-gray-700 dark:text-gray-300 hover:text-primary"
          onClick={() => navigate('/about')}
        >
          About
        </button>
        <button
          className="text-sm font-medium text-gray-700 dark:text-gray-300 hover:text-primary"
          onClick={() => navigate('/feedback')}
        >
          Feedback
        </button>
        <LanguageSwitcher />
        <ThemeToggle />
      </div>
      {/* Mobil hamburger menü */}
      <div className="md:hidden flex items-center">
        <button
          className="p-2"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Open menu"
        >
          <span className="material-symbols-outlined text-2xl">menu</span>
        </button>
        {menuOpen && (
          <div className="absolute top-16 right-6 bg-white dark:bg-gray-900 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 z-50 w-48 py-2">
            <button
              className="block w-full text-left px-4 py-2 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800"
              onClick={() => { setMenuOpen(false); navigate('/about'); }}
            >
              About
            </button>
            <button
              className="block w-full text-left px-4 py-2 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800"
              onClick={() => { setMenuOpen(false); navigate('/feedback'); }}
            >
              Feedback
            </button>
            <div className="px-4 py-2 border-t border-gray-200 dark:border-gray-700">
              <LanguageSwitcher />
            </div>
            <div className="px-4 py-2">
              <ThemeToggle />
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
